// extracted by mini-css-extract-plugin
export default {"myScroll":"ChatComponent_myScroll__k1g95"};